// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import store from './store'
import VueI18n from 'vue-i18n'
import messages from './lang/messages.js'
import { GET_USER, AUTH_LOGOUT, AUTH_REFRESH } from './variables'
import './filters'

Vue.use(VueI18n)
let locale = 'fr' // navigator.language
const i18n = new VueI18n({
	fallbackLocale: 'en',
	locale: locale,
	messages,
	silentTranslationWarn: true,
})

Vue.use(Vuetify, {
	theme: {
		primary: '#ff9d00',
		secondary: '#565966',
		info: '#565966',
		accent: '#ff9d00',
	},
})

Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = process.env.ROOT_API
const token = localStorage.getItem('user-token')
const user = localStorage.getItem('user')
if (token) {
	Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}
let errors = []
Vue.axios.interceptors.response.use(undefined, (error) => {
	return new Promise((resolve, reject) => {
		if (
			error.config &&
			error.response &&
			error.response.status === 401 &&
			error.config &&
			!error.config.__isRetryRequest &&
			error.config.url.indexOf('authenticate') === -1 &&
			store.getters.hasRefreshToken
		) {
			errors.push({
				resolve: resolve,
				reject: reject,
				config: error.config,
			})

			if (errors.length === 1) {
				store
					.dispatch(AUTH_REFRESH)
					.then(() => {
						for (let i = 0; i < errors.length; i++) {
							errors[i].config.__isRetryRequest = true
							Vue.axios.request(errors[i].config).then(errors[i].resolve, errors[i].reject)
						}
						errors = []
					})
					.catch((error) => {
						errors = []
						store.dispatch(AUTH_LOGOUT)
						router.push({ name: 'Login' })
						return Promise.reject(error)
					})
			}
		} else {
			if (
				error.config &&
				error.response &&
				error.response.status === 401 &&
				error.config.url.indexOf('authenticate') === -1
			) {
				errors = []

				router.push({ name: 'Login' })
				store.dispatch(AUTH_LOGOUT)
			}
			reject(error)
		}
	})
})

if (user) {
	store
		.dispatch(GET_USER, user)
		.then(() => {
			if (router.currentRoute.name === 'Login') {
				if (router.currentRoute.query.next) {
					router.push(router.currentRoute.query.next)
				} else {
					router.push({ name: 'ProUserList' })
				}
			}
		})
		.catch((err) => {
			console.log(err)
			store.dispatch(AUTH_LOGOUT)
		})
}

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	i18n,
	components: { App },
	template: '<App/>',
})

export default i18n



// WEBPACK FOOTER //
// ./src/main.js